import * as React from 'react';
import { WYSIWYGEditor } from '../../WYSIWYGEditor/WYSIWYGEditor';
import TooltipPopover from '../../Popover/popover';
import { FieldProps } from '../metadataFormField';

export const LabelField = (props: FieldProps) => {
  const { field } = props;
  const { name, description } = field;
  return (
    <div className="label-field">
      {name || '<Label Name Not Defined>'}
      {!!description?.length && (
        <div className="description">
          <TooltipPopover
            type="info"
            pointerPosition="right"
            content={
              <WYSIWYGEditor
                content={description}
                readonly={true}
                disabled={true}
                onChange={null}
              />
            }
          />
        </div>
      )}
    </div>
  );
};
